import React, { useState, useEffect } from 'react';
import ManageExistingSolutions from './ManageExistingSolutions';
import * as api from '../../services/apis';
import { useKeycloak } from '../../hooks/useKeycloak';

const ManageExistingSolutionsContainer = () => {
  const [renderSolutions, setRenderSolutions] = useState(
    Array.from({ length: 4 }),
  );
  const [originalSolutions, setOriginalSolutions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { logout, userInfo } = useKeycloak();

  const getSolutions = (taxNumber) => {
    api
      .getRegisteredSolutions(taxNumber)
      .then((resp) => {
        setOriginalSolutions(resp?.data?.productionCertificateResponseList);
        setRenderSolutions(resp?.data?.productionCertificateResponseList);
        setLoading(false);
      })
      .catch((err) => {
        if (err?.status === 401) {
          logout();
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    if (userInfo) {
      getSolutions(userInfo.tax_number);
    }
  }, [userInfo]);

  return (
    <ManageExistingSolutions
      solutions={renderSolutions}
      originalSolutions={originalSolutions}
      setRenderSolutions={setRenderSolutions}
      loading={loading}
      getSolutions={getSolutions}
    />
  );
};

export default React.memo(ManageExistingSolutionsContainer);
